'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _dec3, _class3, _class4, _temp2;
// import ReactTooltip from 'react-tooltip'

// import Loader from 'react-loader'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactScroll = require('react-scroll');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _components = require('../../components');

var _TspToolkit = require('./TspToolkit.css');

var _TspToolkit2 = _interopRequireDefault(_TspToolkit);

var _tspSocialShare = require('../../../static/images/tsp-social-share.png');

var _tspSocialShare2 = _interopRequireDefault(_tspSocialShare);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TspFundItem = (_dec = (0, _reactCssModules2.default)(_TspToolkit2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TspFundItem, _Component);

  function TspFundItem(props) {
    (0, _classCallCheck3.default)(this, TspFundItem);
    return (0, _possibleConstructorReturn3.default)(this, (TspFundItem.__proto__ || (0, _getPrototypeOf2.default)(TspFundItem)).call(this, props));
  }

  (0, _createClass3.default)(TspFundItem, [{
    key: 'getShareclassUrl',
    value: function getShareclassUrl(shareclass) {
      // const A = `${config.domain}`
      var B = _config2.default.routes.fund + '/';
      var C = _format2.default.sanitize(shareclass.fund_legal_name) + '/';
      var D = 'N/';
      var E = _config2.default.profilePath + '/';
      var F = shareclass.fund_id + '/';
      var G = shareclass.investment_vehicle_id + '/';

      return '' + B + C + D + E + F + G;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.fund) {
        return null;
      }
      var e = this.props.fund;
      if (!e.grade_fossil) {
        return _react2.default.createElement(
          'div',
          { styleName: 'tsp-fund-item-inactive' },
          e.fund_legal_name === 'L Income' ? e.fund_legal_name : e.fund_legal_name.slice(4, 10),
          ' ',
          _react2.default.createElement(
            'div',
            { styleName: 'tsp-inactive-asterisk' },
            '*'
          )
        );
      }
      return _react2.default.createElement(
        _components.Link,
        {
          to: this.getShareclassUrl(e),
          title: e.fund_legal_name
        },
        _react2.default.createElement(
          'div',
          { styleName: 'tsp-fund-item' },
          e.fund_legal_name.slice(4, 10),
          _react2.default.createElement(
            'div',
            { styleName: 'tsp-fund-item-grade' },
            _react2.default.createElement(
              'span',
              null,
              _format2.default.perc(e.c2f5coogutweight)
            ),
            _react2.default.createElement(_components.Grade, { grade: e.grade_fossil, blocksmall: true })
          )
        )
      );
    }
  }]);
  return TspFundItem;
}(_react.Component), _class2.propTypes = {
  fund: _react.PropTypes.object.isRequired
}, _temp)) || _class);
var TspToolkit = (_dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.tspShareClass.result,
    searching: state.tspShareClass.loading,
    searched: state.tspShareClass.loaded,
    error: state.tspShareClass.error
  };
}, searchActions), _dec3 = (0, _reactCssModules2.default)(_TspToolkit2.default, { allowMultiple: true }), _dec2(_class3 = _dec3(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(TspToolkit, _Component2);

  function TspToolkit(props) {
    (0, _classCallCheck3.default)(this, TspToolkit);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (TspToolkit.__proto__ || (0, _getPrototypeOf2.default)(TspToolkit)).call(this, props));

    var emailTo = '';
    var emailToAdmin = 'thriftline@tsp.gov';
    var emailSubjectAdmin = 'The TSP needs climate safe investment options';
    var emailSubjectColleagues = 'Our retirement savings are fueling the climate crisis';

    var planAdminEmailText = 'Dear Federal Retirement Thrift Investment Board,\n\nI participate in the Federal Thrift Savings (TSP) plan, and I\u2019m writing to ask: How is the TSP managing the climate-related investment risks that are threatening my retirement savings?\n\nI recently learned the TSP invests over $35 billion in fossil fuel companies. Climate change is accelerating, resulting in a growing number of climate-related natural disasters, and the economic impacts are becoming increasingly evident. Climate-related investment risk is the risk that the economic impacts of climate change will cause your investments to suffer losses. Achieving decarbonization of the world economy requires a transition away from carbon-based energy, which will necessarily alter some companies\u2019 businesses. High-carbon industries face some of the most climate risks, and addressing climate-related investment risk usually involves carefully scrutinizing investments in these sectors.\n\nThe TSP has a fiduciary duty of prudent and loyal stewardship, with the responsibility to act in our best interest and protect our life savings from these material, climate-related financial risks. \n\nThe analysis of the fossil fuel investments in the TSP is here:\n\nhttps://fossilfreefunds.org/thrift-savings-plan \n\nI understand TSP plan participants have access to a \u201Cmutual fund window\u201D, also known as a self-directed option. This gives plan participants access to a wider range of fund options, including climate-safe sustainable funds. But the window comes with higher fees, limits on who can use it, and limits on how much can be invested. More broadly, plans that offer self-directed options usually see only between 1 and 2% of plan assets invested through them. Self-directed retirement options shift the practical responsibility for risk management from the plan to the participant. At best, it\u2019s a band-aid that doesn\u2019t address the climate risk facing the vast majority of the plan\'s assets.\n\nI appreciate your time and look forward to hearing from you.\n\nBest,\n\n[Your Name]\n    ';

    var colleagueEmailText = 'Dear [colleague],\n\nI just found out our retirement plan, the Thrift Savings Plan (TSP), is investing over $35 BILLION in fossil fuel companies. Our retirement savings are fueling the climate crisis.\n\nYou can see the analysis on what\'s inside the TSP investment options here:\n\nhttps://fossilfreefunds.org/thrift-savings-plan \n\nI care about solving the climate crisis, and I don\u2019t want my retirement savings invested in companies that are destroying the environment, exposing my nest egg to climate-related financial risk.\n\nWe need sustainable, climate-friendly investment options inside our retirement plan so we can invest in the sustainable economy of the future.\n\nYou can use this toolkit to learn how to invest in a sustainable world:\n\nhttps://fossilfreefunds.org/thrift-savings-plan-toolkit \n\nThank you for taking the time to listen.\n\nBest,\n\n[Your Name]\n    ';

    var planAdminEmailHref = 'mailto:' + emailToAdmin + '?subject=' + encodeURIComponent(emailSubjectAdmin) + '&body=' + encodeURIComponent(planAdminEmailText);

    var colleagueEmailHref = 'mailto:' + emailTo + '?subject=' + encodeURIComponent(emailSubjectColleagues) + '&body=' + encodeURIComponent(colleagueEmailText);

    _this2.state = {
      tspByType: _this2.defaultTspByType(),
      title: 'Five steps to a sustainable retirement through the Thrift Savings Plan (TSP)',
      description: 'Resources for people to take action to make the Thrift Savings Plan (TSP) more sustainable.',
      url: _config2.default.domain + _config2.default.routes.tspToolkit,
      planAdminEmailHref: planAdminEmailHref,
      colleagueEmailHref: colleagueEmailHref
    };
    return _this2;
  }

  (0, _createClass3.default)(TspToolkit, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // if (typeof window !== 'undefined') {
      //   window.scrollTo(0,0)
      // }
      this.props.tspShareClasses();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      // split into L, Ind -> (E, B)
      var tspByType = this.defaultTspByType();

      props.result.forEach(function (r) {
        if (r.fund_legal_name.slice(0, 5) === 'TSP L') {
          tspByType.L.push(r);
        } else {
          tspByType.E.push(r);
        }
      });

      tspByType.L = tspByType.L.sort(function (a, b) {
        return b.fund_legal_name.localeCompare(a.fund_legal_name);
      });
      tspByType.E = tspByType.E.sort(function (a, b) {
        return a.net_assets - b.net_assets;
      });

      tspByType.L.push({ 'fund_legal_name': 'TSP L 2025' });
      tspByType.L.push({ 'fund_legal_name': 'L Income' });

      this.setState({
        tspByType: tspByType
      });
    }
  }, {
    key: 'defaultTspByType',
    value: function defaultTspByType() {
      return {
        'L': [],
        'E': [],
        'B': []
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var finRisk1 = require('../../../static/images/fin-risk-oil-chart.jpg');
      var finRisk2 = require('../../../static/images/fin-risk-deforestation.jpg');
      var navIcons = {
        1: require('../../../static/images/action-center-employees/icon1.jpg'),
        2: require('../../../static/images/action-center-employees/icon2.jpg'),
        3: require('../../../static/images/action-center-employees/icon3.jpg'),
        4: require('../../../static/images/action-center-employees/icon4.jpg'),
        5: require('../../../static/images/action-center-employees/icon5.jpg')
      };

      var _state = this.state,
          planAdminEmailHref = _state.planAdminEmailHref,
          colleagueEmailHref = _state.colleagueEmailHref;

      var socialShareUrl = _config2.default.domain + _tspSocialShare2.default.replace(/.*dist/, '/dist');

      return _react2.default.createElement(
        'div',
        { id: 'top' },
        _react2.default.createElement(_reactHelmet2.default, { meta: [{ property: 'og:image', content: socialShareUrl }, { property: 'twitter:image', content: socialShareUrl }] }),
        _container2.default.helmet(this.statetitle, this.statedescription, this.stateurl),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h1',
              { styleName: 'small-page-title' },
              this.state.title
            ),
            _react2.default.createElement(
              'section',
              null,
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Are your retirement savings funding the climate crisis through the Thrift Savings Plan (TSP)? If you don\u2019t know, you\u2019re not alone. The TSP invests more than $700 billion on behalf of over 6 million civilian and military plan participants, but very few know which companies they are funding with their retirement dollars. Using this toolkit, you will learn how to lower your financial risks from unsustainable investments and maybe even help your co-workers do the same.'
                )
              )
            ),
            _react2.default.createElement(
              'nav',
              { styleName: 'icon-nav' },
              [[0, 'learn-about-the-financial-risks-of-unsustainable-investments', 'Learn about the financial risks of unsustainable investments'], [0, 'know-what-you-own', 'Know what you own'], [0, 'take-action', 'Take action'], [0, 'become-a-change-agent', 'Become a change agent'], [0, 'join-the-movement', 'Join the movement']].map(function (e, i) {
                return _react2.default.createElement(
                  'button',
                  {
                    key: e[1],
                    styleName: 'scroll-to-item'
                  },
                  _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      to: e[1],
                      spy: true,
                      smooth: true,
                      offset: 0,
                      duration: 500,
                      title: e[2]
                    },
                    _react2.default.createElement('img', {
                      src: navIcons[i + 1],
                      alt: e[2]
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'level-' + e[0] },
                      e[2]
                    )
                  )
                );
              })
            ),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { styleName: 'answer' },
              _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement('div', { styleName: 'anchor', id: 'learn-about-the-financial-risks-of-unsustainable-investments' }),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'answer-subtitle-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-subtitle-bbl' },
                    '1'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    'Learn about the financial risks of unsustainable investments'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer-info' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'text-img-cols' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'text-img-cols-text' },
                      _react2.default.createElement(
                        'h3',
                        null,
                        'Unsustainable investments could put your 401(k) at risk'
                      ),
                      _react2.default.createElement(
                        'p',
                        null,
                        'There is a widespread myth that investing sustainably means sacrificing returns. But if anything, the evidence suggests the opposite is true. ',
                        _react2.default.createElement(
                          _components.Link,
                          {
                            to: 'https://investyourvalues.org/action-center/financial-risks',
                            title: 'Financial risks of unsustainable investments',
                            xstrong: true
                          },
                          'Learn more',
                          _react2.default.createElement(_components.LinkIcon, null)
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'text-img-cols-img' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: 'https://investyourvalues.org/action-center/financial-risks',
                          title: 'Financial risks of unsustainable investments'
                        },
                        _react2.default.createElement('img', {
                          src: finRisk1,
                          alt: 'Financial risks of unsustainable investments'
                        })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'text-img-cols' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'text-img-cols-text' },
                      _react2.default.createElement(
                        'h3',
                        null,
                        'The TSP is fueling the climate crisis'
                      ),
                      _react2.default.createElement(
                        'p',
                        null,
                        'The TSP invests over $35 billion in fossil fuel companies which are fueling the climate crisis. We can\'t meet the goals of the Paris Climate Agreement and limit global warming to 1.5\u02DAC while expanding coal, oil, and gas. ',
                        _react2.default.createElement(
                          _components.Link,
                          {
                            to: 'https://investyourvalues.org/the-issues/fossil-fuels',
                            title: 'Asset managers are investing in the climate crisis',
                            xstrong: true
                          },
                          'Learn more',
                          _react2.default.createElement(_components.LinkIcon, null)
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'text-img-cols-img' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: 'https://investyourvalues.org/the-issues/fossil-fuels',
                          title: 'Asset managers are investing in the climate crisis'
                        },
                        _react2.default.createElement('img', {
                          src: finRisk2,
                          alt: 'Asset managers are investing in the climate crisis'
                        })
                      )
                    )
                  ),
                  _react2.default.createElement(_components.ScrollToTop, null),
                  _react2.default.createElement('hr', null)
                )
              ),
              _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement('div', { styleName: 'anchor', id: 'know-what-you-own' }),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'answer-subtitle-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-subtitle-bbl' },
                    '2'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    'Know what you own'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer-info' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Now that you have uncovered the risk associated with unsustainable retirement investments, it\u2019s time to find out if your investments are exposed to these risks.'
                  ),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Find your investments'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'To start, ',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://www.tsp.gov/login/',
                        title: 'TSP.gov Login',
                        xstrong: true
                      },
                      'log in'
                    ),
                    ' to your TSP account to look up what fund(s) you are currently invested. Write your fund(s) down then continue to the next step.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'one-col' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://www.tsp.gov/login/',
                        title: 'TSP.gov Login',
                        transparentbutton: true
                      },
                      'TSP.gov Login',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Find your fund grades'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Now visit our TSP analysis to look up the fossil fuel grades for your investments.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'funds-nav-wrap' },
                    this.state.tspByType.E.map(function (e, i) {
                      return _react2.default.createElement(TspFundItem, { key: 'l-funds-' + i, fund: e });
                    }),
                    this.state.tspByType.L.map(function (e, i) {
                      return _react2.default.createElement(TspFundItem, { key: 'l-funds-' + i, fund: e });
                    }),
                    [{ 'fund_legal_name': 'TSP G Fund' }, { 'fund_legal_name': 'TSP F Fund' }].map(function (e, i) {
                      return _react2.default.createElement(TspFundItem, { key: 'l-funds-' + i, fund: e });
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'one-col' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.tspLanding,
                        title: 'TSP homepage | Fossil Free Funds',
                        transparentbutton: true
                      },
                      'See full analysis',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'i',
                      null,
                      '* Bond fund results are currently unavailable. Check back soon.'
                    )
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(_components.ScrollToTop, null),
                  _react2.default.createElement('hr', null)
                )
              ),
              _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement('div', { styleName: 'anchor', id: 'take-action' }),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'answer-subtitle-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-subtitle-bbl' },
                    '3'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    'Take action'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer-info' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Consider the self-directed option'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'In 2022, the TSP added a "mutual fund window", also known as a self-directed option. This gives plan participants access to a wider range of fund options, including climate-safe sustainable funds.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      _react2.default.createElement(
                        'i',
                        null,
                        'Take note:'
                      )
                    ),
                    ' The self-directed option comes with higher fees, limits on who can use it, and limits on how much can be invested. More broadly, plans that offer self-directed options usually see only between 1 and 2% of plan assets invested through them. Self-directed retirement options shift the practical responsibility for risk management from the plan to the participant. At best, it\u2019s a band-aid that doesn\u2019t address the climate risk facing the vast majority of the plan\'s assets.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'You can use our Fossil Free Funds database to find mutual funds that avoid fossil fuel investments. Some, though not all, of these funds may be available through the TSP mutual fund window.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'one-col' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.list,
                        title: 'Search funds | Fossil Free Funds',
                        transparentbutton: true
                      },
                      'Fossil Free Funds',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  _react2.default.createElement(_components.ScrollToTop, null),
                  _react2.default.createElement('hr', null)
                )
              ),
              _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement('div', { styleName: 'anchor', id: 'become-a-change-agent' }),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'answer-subtitle-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-subtitle-bbl' },
                    '4'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    'Become a change agent'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer-info' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Contact the TSP plan administrator'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'The ',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://www.frtib.gov/',
                        title: 'Federal Retirement Thrift Investment Board',
                        xstrong: true
                      },
                      'Federal Retirement Thrift Investment Board (FRTIB)'
                    ),
                    ' is the TSP plan administrator, charged by law to administer the TSP solely in the interest of the participants and beneficiaries. Here\u2019s an email we have written for you to get started.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'one-col' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: planAdminEmailHref,
                        title: 'Email your plan admin',
                        targetBlank: true
                      },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'take-action-icons' },
                        _react2.default.createElement(
                          'p',
                          null,
                          'Email your plan admin'
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-envelope' })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Email your co-workers and form a coalition'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'If you\u2019re writing to someone in power, advocating on behalf of 20 or even 10 people carries a lot more weight than just one. One way to spur interest would be to share the results from our tools with your fellow employees. All plan participants are offered the same basket of mutual funds as you are, so they are probably asking the same questions are you are right now.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'one-col' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: colleagueEmailHref,
                        title: 'Email your colleagues',
                        targetBlank: true
                      },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'take-action-icons' },
                        _react2.default.createElement(
                          'p',
                          null,
                          'Email your colleagues'
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-envelope' })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(_components.ScrollToTop, null),
                  _react2.default.createElement('hr', null)
                )
              ),
              _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement('div', { styleName: 'anchor', id: 'join-the-movement' }),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'answer-subtitle-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-subtitle-bbl' },
                    '5'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    'Join the movement'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer-info' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Now it is time to join the movement by advocating your power to invest in an economy that is based on justice and sustainability.'
                  ),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Sign up for updates'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'We\'ll let you know when new information is added to our database.'
                  ),
                  _react2.default.createElement(_components.SignupForm, null),
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Support ',
                    _react2.default.createElement(
                      'i',
                      null,
                      'As You Sow'
                    )
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'i',
                      null,
                      'As You Sow'
                    ),
                    ', the nonprofit behind Invest Your Values, has leveraged the power of shareholders to change the world\u2019s biggest corporations for good since 1992. Every day, your gift helps tackle today\u2019s toughest issues, like climate change, racial justice, ocean plastics, toxins in the food system, egregious CEO pay, and slavery in corporate supply chains. Consider joining our family of donors.'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'one-col' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.donate,
                        title: 'Donate to As You Sow',
                        transparentdonatebutton: true
                      },
                      'Donate to ',
                      _react2.default.createElement(
                        'i',
                        null,
                        'As You Sow'
                      ),
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(_components.ScrollToTop, null),
                  _react2.default.createElement('hr', null)
                )
              )
            )
          )
        )
      );
    }
  }]);
  return TspToolkit;
}(_react.Component), _class4.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array
}, _class4.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp2)) || _class3) || _class3);
exports.default = TspToolkit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TspToolkit/TspToolkit.js
// module id = 1423
// module chunks = 0